<div class="!z-[900] flex flex-col h-dvh font-inter bg-p-content-background px-4 pt-4 pb-2">
    <div class="flex items-center justify-between p-4 pt-0 shrink-0">
        @if (currentUser.userId) {
            <div class="flex flex-col items-start justify-start w-full gap-2">
                <div class="w-full flex flex-row justify-between items-start">
                    <fm-avatar [sizePx]="48" [avatarLocation]="currentUser.photo" />
                    <p-button
                        [buttonProps]="{ autofocus: false }"
                        routerLink="/profile"
                        (click)="onClickMenuItem()"
                        class="flex"
                        size="small"
                        severity="secondary"
                        styleClass="aspect-square"
                        icon="pi pi-id-card" />
                </div>
                <div class="flex flex-col items-start justify-start w-full gap-1">
                    <div
                        class="w-full text-left text-base leading-normal font-semibold text-color wrap-double-line-el"
                        ><fm-home-welcome-message />,<br />{{ currentUser.firstName }}!</div
                    >
                    <div class="text-12 leading-[normal] text-muted-color font-light max-h-[18px]">
                        {{ currentUser.compSessions.toLocaleString('en-US') }}
                        {{
                            currentUser.compSessions > 1 || currentUser.compSessions == 0
                                ? 'sessions'
                                : 'session'
                        }}
                    </div>
                    @if (
                        currentUser.ambassadorSessionsAttended > 0 ||
                        (currentUser.isHost && featureCheckService.groupMeetingsEnabledSig())
                    ) {
                        <div class="flex flex-row items-center gap-2">
                            @if (currentUser.ambassadorSessionsAttended > 0) {
                                <fm-ambassador-sessions-badge
                                    size="small"
                                    [ambassadorSessionsAttended]="
                                        currentUser.ambassadorSessionsAttended
                                    " />
                            }
                            <fm-host-badge
                                size="small"
                                [isHost]="!!currentUser.isHost"
                                [groupSessionsHosted]="currentUser.groupSessionsHosted ?? 0"
                                [viewingSelf]="true" />
                        </div>
                    }
                    <div class="text-12 leading-[normal] text-muted-color font-light">
                        {{ planNameString }}
                    </div>
                    @if (trialDaysRemaining && trialDaysRemaining > 0) {
                        <p-message severity="warn" variant="text" styleClass="w-full !rounded-lg">
                            <ng-template #container>
                                <div
                                    class="w-full flex items-center justify-center font-semibold text-[12px]">
                                    {{ trialDaysRemaining }} days left in trial
                                </div>
                            </ng-template>
                        </p-message>
                    }
                </div>
                @if (showUpgradeButton) {
                    <p-button
                        routerLink="/upgrade"
                        [state]="{ source: 'mobileMenu' }"
                        [buttonProps]="{ autofocus: false }"
                        (click)="onClickMenuItem()"
                        severity="primary"
                        label="Upgrade to Plus"
                        size="small" />
                }
            </div>
        }
    </div>

    <div class="w-full border-b border-latte my-4"></div>

    @if (!welcomeChecklistService.isWelcomeChecklistActive() && hasYearlyReview) {
        <div
            class="relative flex flex-row items-center justify-center p-[12px] w-full bg-[#F8E2E2] rounded-2xl cursor-pointer shadow-p-form-field-shadow overflow-hidden border-[2px] border-blurple-2 mb-4"
            (click)="onClickYearInFocus()">
            <div
                class="absolute bg-confetti-blue-pattern bg-center w-full h-full"
                [ngClass]="{
                    'bg-[length:250px] bg-repeat': true,
                }">
                <img
                    class="absolute left-0 h-[150%] translate-y-[-25%]"
                    src="/assets/images/year-in-review/computer.webp" />
            </div>
            <div class="z-[1] w-full text-center text-primary font-semibold text-lg leading-5"
                >Year in Focus</div
            >
        </div>
    }

    <div class="w-full flex flex-col overflow-y-auto gap-4">
        @if (isTaskManagerEnabled()) {
            <p-button
                [buttonProps]="{ autofocus: false }"
                (click)="onClickMenuItem()"
                severity="secondary"
                routerLink="/tasks"
                class="w-full"
                styleClass="w-full">
                <div class="w-full flex items-center justify-between">
                    <div class="flex items-center gap-1.5">
                        <i class="pi pi-check-square" style="font-size: 14px"></i>
                        <span class="font-medium">Task Manager</span>
                        <p-tag
                            styleClass="!text-10 !leading-[normal] !rounded-md !font-medium !px-1.5 !py-0.5"
                            severity="info"
                            value="Labs" />
                    </div>
                    <div class="flex items-center justify-center"
                        ><i class="pi pi-chevron-right" style="font-size: 14px"></i
                    ></div>
                </div>
            </p-button>
        }

        @if (isGroupMeetingsEnabled()) {
            <p-button
                [buttonProps]="{ autofocus: false }"
                (click)="onClickGroupSessions()"
                severity="secondary"
                class="w-full"
                styleClass="w-full">
                <div class="w-full flex items-center justify-between">
                    <div class="flex items-center gap-1.5">
                        <fm-icon name="flower" size="14px" />
                        <span class="font-medium">Group Sessions</span>
                        <p-tag
                            styleClass="!text-10 !leading-[normal] !rounded-md !font-medium !px-1.5 !py-0.5"
                            severity="info"
                            value="Labs" />
                    </div>
                    <div class="flex items-center justify-center"
                        ><i class="pi pi-chevron-right" style="font-size: 14px"></i
                    ></div>
                </div>
            </p-button>
        }
        <p-button
            [buttonProps]="{ autofocus: false }"
            (click)="onClickMenuItem()"
            routerLink="/people"
            severity="secondary"
            class="w-full"
            styleClass="w-full">
            <div class="w-full flex items-center justify-between">
                <div>
                    <fa-icon [icon]="faUserGroup" style="font-size: 14px" />

                    <span class="ml-2 font-medium">People</span>
                </div>
            </div>
            <div class="flex items-center justify-center"
                ><i class="pi pi-chevron-right" style="font-size: 14px"></i
            ></div>
        </p-button>
        <p-button
            [buttonProps]="{ autofocus: false }"
            (click)="onClickMenuItem()"
            routerLink="/settings"
            severity="secondary"
            class="w-full"
            styleClass="w-full">
            <div class="w-full flex items-center justify-between">
                <div>
                    <fa-icon [icon]="faGear" style="font-size: 14px" />

                    <span class="ml-2 font-medium">Settings</span>
                </div>
            </div>
            <div class="flex items-center justify-center"
                ><i class="pi pi-chevron-right" style="font-size: 14px"></i
            ></div>
        </p-button>
        <p-button
            [buttonProps]="{ autofocus: false }"
            (click)="openHelpFeedbackModal()"
            severity="secondary"
            class="w-full"
            styleClass="w-full">
            <div class="w-full flex items-center justify-between">
                <div>
                    <fa-icon [icon]="faHandWave" style="font-size: 14px" />
                    <span class="ml-2 font-medium">Help and Feedback</span>
                </div>
            </div>
            <div class="flex items-center justify-center"
                ><i class="pi pi-chevron-right" style="font-size: 14px"></i
            ></div>
        </p-button>
        <p-button
            [buttonProps]="{ autofocus: false }"
            (click)="onClickMenuItem()"
            routerLink="/refer"
            severity="secondary"
            class="w-full"
            styleClass="w-full">
            <div class="w-full flex items-center justify-between">
                <div>
                    <fa-icon [icon]="faGift" style="font-size: 14px" />

                    <span class="ml-2 font-medium">Refer</span>
                </div>
            </div>
            <div class="flex items-center justify-center"
                ><i class="pi pi-chevron-right" style="font-size: 14px"></i
            ></div>
        </p-button>

        @if (isFmAdmin || isGroupAdmin) {
            <p-button
                [buttonProps]="{ autofocus: false }"
                (click)="onClickMenuItem()"
                routerLink="/group-management"
                severity="secondary"
                class="w-full"
                styleClass="w-full">
                <div class="w-full flex items-center justify-between">
                    <div>
                        <fa-icon [icon]="faUsersMedical" style="font-size: 14px" />

                        <span class="ml-2 font-medium">Group Management</span>
                    </div>
                </div>
                <div class="flex items-center justify-center"
                    ><i class="pi pi-chevron-right" style="font-size: 14px"></i
                ></div>
            </p-button>
        }
        @if (isFmAdmin) {
            <p-button
                [buttonProps]="{ autofocus: false }"
                (click)="onClickMenuItem()"
                routerLink="/admin"
                severity="secondary"
                class="w-full"
                styleClass="w-full">
                <div class="w-full flex items-center justify-between">
                    <div>
                        <fa-icon [icon]="faAdminIcon" style="font-size: 14px" />

                        <span class="ml-2 font-medium">Admin Console</span>
                    </div>
                </div>
                <div class="flex items-center justify-center"
                    ><i class="pi pi-chevron-right" style="font-size: 14px"></i
                ></div>
            </p-button>
        }
        <p-button
            [buttonProps]="{ autofocus: false }"
            (click)="onClickMenuItem()"
            [routerLink]="'/session/' + currentUser.userId"
            severity="secondary"
            class="w-full"
            styleClass="w-full">
            <div class="w-full flex items-center justify-between">
                <div>
                    <fa-icon [icon]="faVideo" style="font-size: 14px" />

                    <span class="ml-2 font-medium">Test Audio and Video</span>
                </div>
            </div>
            <div class="flex items-center justify-center"
                ><i class="pi pi-chevron-right" style="font-size: 14px"></i
            ></div>
        </p-button>

        <p-button
            [buttonProps]="{ autofocus: false }"
            (click)="onClickMenuItem()"
            class="w-full"
            styleClass="w-full !justify-start"
            severity="secondary"
            label="Sign out"
            icon="pi pi-sign-out"
            (click)="onClickLogOut()" />

        <!-- Account for upcmoming session banner -->
        @if (upcomingSessionsService.visible()) {
            <div class="h-12 min-h-12"></div>
        }
        <!-- Account for navigation bar -->
        <div class="h-[53px] min-h-[53px]"></div>
    </div>
</div>
